var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoneAll = function SvgDoneAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 4.667-.94-.94-4.227 4.226.94.94zm2.826-.94L7.773 10.78 4.987 8l-.94.94 3.726 3.727 8-8zM.273 8.94 4 12.667l.94-.94L1.22 8z"
  })));
};
export default SvgDoneAll;